import { VERSION } from "./version";

/**
 * Notas de versión en español. La clave debe coincidir con VERSION
 * para que el modal “Novedades” muestre el resumen correcto.
 */
export const RELEASE_NOTES = {
  "1.14.10": {
    title: "Corcho libre otra vez",
    summary:
      "Fichas arrastrables con posición persistida (corkboardScopes). Path Escritorio › Cajón › Cuaderno visible. Corcho con hueco para soltar.",
    highlights: [
      "Drag libre + snap; layout por carpeta/cuaderno",
      "Dónde estoy: path bajo el título Corcho",
      "Raíz = carpetas (+ fijadas); Abrir → no pelea con el drag",
    ],
    howTo: [
      "Arrastrá la ficha; Abrir/Entrar abre. Esc sube de carpeta.",
      "El selector de cuaderno muestra Escritorio · Cajón · Cuaderno.",
    ],
  },
  "1.14.9": {
    title: "Corcho: limpio y arrastrable",
    summary:
      "Raíz solo carpetas (no 180 notas random). Sin Kanban ni filtros basura. Fondo corcho, fichas crema. Arrastrás la ficha; Abrir/Entrar o clic sin drag.",
    highlights: [
      "Drag en toda la ficha; clic post-drag no abre",
      "Raíz = carpetas + fijadas; link para notas sueltas",
      "Fondo corcho CSS + tarjeta tipo index card",
      "Toolbar mínima: cuaderno, migas, + / salir",
    ],
    howTo: [
      "Arrastrá la ficha por el cuerpo. Abrir = botón o clic corto.",
      "Raíz limpia; entrá a una carpeta para ver sus notas.",
    ],
  },
  "1.14.8": {
    title: "Corcho estilo Scrivener",
    summary:
      "El corcho es vista de carpeta: elegís cuaderno, ves hijos como tarjetas, entrás a carpetas. Posición libre con snap suave y animaciones al soltar / cambiar de carpeta.",
    highlights: [
      "Scope por cuaderno + drill de carpetas (breadcrumb)",
      "Layouts por carpeta en settings.corkboardScopes",
      "Snap a grilla (paso 2) + settle / scope transitions",
      "Clic en carpeta = entrar; nota = URL única",
    ],
    howTo: [
      "Abrí /corkboard → elegí cuaderno → arrastrá por el asa.",
      "Convertí una nota en carpeta y entrá con un clic.",
      "Esc vuelve a la carpeta padre.",
    ],
  },
  "1.14.7": {
    title: "Dictado: Copiar + Despejar + Robot",
    summary:
      "En el editor de manuscrito (Mic), Copiar es el botón principal — más grande que Guardar. Despejar vacía el dictado sin tocar las instrucciones del robot. Mismo modo agente que Hoy.",
    highlights: [
      "Botón Copiar grande (dictado → portapapeles)",
      "Botón Despejar: limpia dictado, conserva prompt robot",
      "Modo robot [🤖]: anexá instrucciones fijas al copiar",
      "Doble toque = auto-loop (limpia tras copiar)",
      "Mismas instrucciones que la captura de Hoy (localStorage compartido)",
    ],
    howTo: [
      "Abrí Mic → dictá → tocá Copiar (manda instrucciones + texto).",
      "Tocá [🤖] para el campo de instrucciones; Despejar no las borra.",
      "Doble toque en [🤖] activa auto: Copiar limpia el dictado.",
    ],
  },
  "1.14.6": {
    title: "Kanban + Corcho URLs",
    summary:
      "/kanban con 4–9 columnas renombrables y DnD; /corkboard tarjetas 10×15. Overlay soft en settings, sin tocar la jerarquía.",
    highlights: [
      "Ruta /kanban: columnas Bandeja → Hecho (añadir/quitar 4–9)",
      "Renombrar columnas (lápiz / doble clic)",
      "Corcho: tamaño por defecto 10×15; link cruzado a Kanban",
      "Links en menú externo + breadcrumb",
    ],
    howTo: [
      "Abrí /kanban — arrastrá notas entre columnas.",
      "Lápiz o doble clic en el título para renombrar.",
      "/corkboard muestra todas las notas como tarjetas 10×15.",
    ],
  },
  "1.14.5": {
    title: "Never lose text (doctrina P0)",
    summary:
      "Contrato explícito: el texto del usuario no desaparece. 15 fallbacks documentados, bóveda dual, banner al reiniciar, Esc ya no borra en silencio.",
    highlights: [
      "Doc canónica: docs/human/00_overview/never-lose-text.md",
      "Banner global si hay dictationEmergencyVault recuperable",
      "Flush al ocultar pestaña / beforeunload",
      "QuickCapture: Esc confirma y conserva vault",
    ],
    howTo: [
      "Si ves el banner dorado abajo: Copiar / Ver el texto recuperado.",
      "Dictá → F5: el texto debe poder restaurarse.",
    ],
  },
  "1.14.4": {
    title: "Dictado: nunca más perder el texto",
    summary:
      "Hotfix de outage: el dictado largo ya no puede borrarse al hacer click o al cortar el mic. Hay bóveda local de emergencia y restauración automática.",
    highlights: [
      "El interim se confirma al cerrar el mic (antes podía quedar solo en pantalla).",
      "Bóveda local dictationEmergencyVault mientras hablás.",
      "El canvas y el editor bloquean borrados accidentales a vacío.",
      "Cerrar sin guardar pide confirmación y conserva el borrador.",
    ],
    howTo: [
      "Si perdiste texto hoy: abrí Hoy o Mic — si hay bóveda, tocá Restaurar.",
      "O DevTools → Application → Local Storage → dictationEmergencyVault.",
    ],
  },
  "1.13.2": {
    title: "Confianza Deepgram palabra a palabra",
    summary:
      "El dictado en vivo pinta cada palabra en blanco con opacidad = confianza (100% → blanco pleno, 10% → 10%). Hay una nota pinneada en Ayuda › Referencia › APIs con el payload rico de ejemplo.",
    highlights: [
      "Opacidad continua por word.confidence (ya no umbrales oro/rojo).",
      "Nota «Deepgram — payload rico…» con JSON crudo + objeto parseado por Trufapp.",
      "Demo visual en la nota: cada palabra con su % de certeza.",
      "Toggle ES/EN/LA sigue activo; LA usa language=multi en Deepgram.",
    ],
    howTo: [
      "Abrí el Mic o /editor y dictá: las palabras tentativas se atenúan según certeza.",
      "Pasá el cursor por una palabra para ver el % en el tooltip.",
      "Buscá «Deepgram» en el árbol o en Ayuda › Referencia › APIs.",
    ],
  },
  "1.13.1": {
    title: "Proyectos como notas-carpeta",
    summary:
      "Ahora cada proyecto es una nota que funciona como carpeta de Scrivener: el checklist son notas hijas reales, no líneas de markdown.",
    highlights: [
      "En Panel → Proyectos creás un proyecto (nota con tipo carpeta).",
      "Cada ítem del checklist es una nota: la abrís, la editás y la marcás hecha.",
      "Un ítem puede ser otra carpeta (subproyecto) y anidar más notas.",
      "En el árbol lateral las carpetas se expanden; arrastrá una nota sobre una carpeta para anidarla.",
      "Al leer un proyecto ves la lista «Notas del proyecto» debajo del cuerpo.",
      "En el celular, Proyectos va en una columna y Tablero apila las tarjetas (sin arrastrar la grilla).",
    ],
    howTo: [
      "Abrí /dashboard y deslizá hasta Proyectos.",
      "Escribí el nombre y tocá PROYECTO.",
      "Expandí la tarjeta, agregá ítems (marcá «carpeta» si querés un subproyecto).",
      "Tocá un ítem para leerlo o editarlo; usá el checkbox para marcarlo hecho.",
      "Buscá la nota «Novedades v1.13» en el vault si querés releer esta guía.",
    ],
  },
};

export function getReleaseNotes(version = VERSION) {
  return RELEASE_NOTES[version] || null;
}

export const WHATS_NEW_STORAGE_KEY = "trufapp:lastSeenVersion";
